<ul class="pipe-track" [attr.data-size]="size()" [attr.aria-label]="label() || null">
  @for (cell of cells(); track $index) {
    <li
      class="pipe-track__cell"
      [class.pipe-track__cell--pulsing]="cell.status === 'running'"
      [attr.data-status]="cell.status"
      [attr.title]="cell.label"
    >
      <span class="sr-only">{{ cell.label }}</span>
    </li>
  }
</ul>
